import React, { useState } from "react"
import { CookieConsentProps } from "../../interfaces"
import CookiePic from '../../images/defaults/cookie_cut.png'
import { Link } from "react-router-dom"

const CookieConsent: React.FC<CookieConsentProps> = ({ activeLanguage, giveCookieConsent }) => {

    return (
        <div className="flex flex-col bg-white fixed w-full max-w-[95%] right-[2.5%] bottom-4 sm:right-4 sm:w-[470px] rounded-md shadow-md px-3 py-4 gap-4 z-50 mx-auto sm:mx-0">
            <div className="flex gap-2">
                <img src={CookiePic} alt="Consent Cookie" className="h-8 animate-rotate-to-30-and-back-with-delay" />
                <div className="text-sm text-neutral-600">
                    We use only the necessary cookies to ensure that we offer you the best experience while browsing our website. Check our Privacy Policy for more information.
                </div>
            </div>
            <div className="flex gap-2">
                <Link to={`${activeLanguage == 'en' ? '/en' : ''}/privacy-policy`} className="bg-neutral-200 rounded-full px-3 py-1.5 text-sm text-neutral-700">
                    Learn More
                </Link>
                <button onClick={giveCookieConsent} className="bg-main text-white rounded-full px-3 py-1.5 text-sm">
                    Accept
                </button>
            </div>
        </div>
    )

}

export default CookieConsent;